import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators';

import { getQueryStringParameters } from '../helpers/urls';
import { loadGoogleMapsApi } from '../helpers/api/google-api';

@customElement('nomination-page')
export class NominationPage extends LitElement {
    amplitude_callsite: string = 'Point Page';

    @state()
    focused_point_id: string | undefined;

    async firstUpdated() {
        await loadGoogleMapsApi();
        const queryString = getQueryStringParameters();
        const point_id = queryString.get('point_id');
        this.focused_point_id = point_id ?? undefined;

        window.dispatchEvent(new CustomEvent('page-content-ready'));
    }

    render() {
        return html`
            <div class="points__page_wrapper">
                <nomination-component
                    .selected_point_id="${this.focused_point_id}"
                ></nomination-component>
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            .points__page_wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 50px 15%;
                flex:1;
            }

            nomination-component {
                width: 100%;
                height: 100%;
            }

            @media only screen and (max-width: 550px) {
                .points__page_wrapper {
                    padding: 0;
                    width: 100%;
                    height: 100%;
                }
        `;
    }
}

